export const Diet = [
    { label: "Open to all", value: "open to all" },
    { label: "Veg", value: "veg" },
    { label: "Non-veg", value: "non-veg" },
    { label: "Vegan", value: "vegan" }
]